import { useState, type FormEvent, type ReactNode } from "react";
import { Link } from "react-router-dom";
import { Button, TextField, vars } from "@pack-it-up/ui-web";
import { useStoreValue } from "@pack-it-up/viewmodel/bindings";
import { useStores } from "../../app/AppContext.js";
import { AuthCard, AuthError } from "./AuthCard.js";
import { forgotPasswordSchema, isValid } from "./schemas.js";

export const ForgotPassword = (): ReactNode => {
  const { auth } = useStores();
  const error = useStoreValue(auth, (s) => s.error);
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const valid = isValid(forgotPasswordSchema, { email });

  const onSubmit = async (e: FormEvent): Promise<void> => {
    e.preventDefault();
    if (!valid || submitting) return;
    setSubmitting(true);
    const r = await auth.getState().sendPasswordReset(email);
    setSubmitting(false);
    if (r.ok) setSent(true);
  };

  return (
    <AuthCard title="Reset password" footer={<Link to="/signin">Back to sign in</Link>}>
      {sent ? (
        <p role="status" style={{ margin: 0, color: vars.color.textMuted, fontSize: vars.font.sizeMd }}>
          If an account exists for {email}, a reset link is on its way.
        </p>
      ) : (
        <form onSubmit={onSubmit} style={{ display: "flex", flexDirection: "column", gap: "16px" }} noValidate>
          <TextField label="Email" type="email" autoComplete="email" value={email} onChange={setEmail} />
          {error !== null && <AuthError message={error} />}
          <Button type="submit" disabled={!valid || submitting}>
            {submitting ? "Sending…" : "Send reset link"}
          </Button>
        </form>
      )}
    </AuthCard>
  );
};
